define('views/shared/form/input/state_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/state_component.html',
    'models/shared/lookups/lookups',
    'models/shared/user/user'
], function(Backbone, BaseView, Template, LookupsModel, UserModel){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        needsAuth: false,
        activityIndicator: false,
        template : _.template(Template),
        events   : {
            'change select': 'handleTextInput'
        },

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.field = options.field;

            this.user_model = null;

            this.is_valid = false;
            this.error = false;
            this.error_feedback = this.field.error.empty;

            this.states_loaded = false;

            this.state_id = -1;

            this.muted = options.muted;
            
            this.elementName = options.elementName;

            console.log('state field', this.field);
            

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            console.log('muted', this.muted);
            

            this.$el.html(this.template({ muted: this.muted }));

            that.showStates();

            return this;
        },

        loadData: function(){
            var that = this;

            this.$('.spinner').remove();

            store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get('UserGUID') }, false, true, true, function(Data){
                var user_model = new UserModel(Data);

                that.user_model = user_model.toJSON();

                that.getStates();
            });
            
        },

        getStates: function(){
            var that = this;

            this.states = new LookupsModel();

            this.states.fetch({
                url    : pf.lookupsURL + '/States',
                success: function(states_model, resp){

                    that.render();

                    that.states_loaded = true;

                    if(that.state_id >= 0){
                        that.updateValue(that.state_id);
                    }

                }
            });

        },

        showStates: function(){

            var that = this;

            if(this.states != null){

                this.states.each(function(state){
                    var option = $("<option value=" + state.ID + ">" + state.Name + "</option>");
                    that.$el.find('select').append(option);
                });

            }

        },

        updateValue: function(StateID){

            if(this.states_loaded){

                this.$el.find('select').find('option[value=' + ((StateID === undefined) ? -1 : StateID) + ']').attr('selected', true);
                this.handleTextInput();

            } else {
                this.state_id = StateID;
            }
        },

        getValue: function(){

            return {
                one: this.$el.find('select').find(':selected').text(),
                two: this.state_id
            };
            
        },

        handleTextInput: function(e){
            var input = this.$el.find('select').find(':selected');

            if(input.val() == '' || !input.val()){

                this.error_feedback = this.field.error.empty;
                this.is_valid = false;
                this.showError();

            } else {
                
                this.is_valid = true;
                this.state_id = input.val();
                this.removeError();
                
            }

            this.context.updateStatus();

        },

        showError: function(){
            this.error = true;
            this.$el.find('.js-form-input-feedback').html(this.error_feedback);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
        },

        close: function(){}
    });
});

